import React, { useContext } from 'react';
import './detailstyle.css';
import './style.css';
import { Link } from "react-router-dom";
import { CartContext } from "./products/productsContext"
// import CartImage from './images/cart'

const Navbar = () => {
  const [showCart, setShowCart] = useContext(CartContext)

  const handleCartOpen = () => {
    setShowCart(true)
  }

  return (

    <nav className="navbar navbar-expand-md fixed-bottom  p-3 mb-5 rounded">
      <div className="navbar-header">
        <Link className="navbar-brand"  to="/merch">
          <img alt="" src="https://clydemays.com/images/glob-main-logo-black.svg" /></Link>
        <button className="navbar-toggler toggle-button" type="button" data-toggle="collapse" 
        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent">
          <span className="navbar-toggler-icon"></span>
        </button>
      </div>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item active ">
           <Link to="/merch" className="nav-link pt-4 my-2 my-lg-0">
           Home <span className="sr-only">(current)</span>
           </Link> 
          </li>
          {!showCart &&

          <li className="nav-item" onClick={handleCartOpen}>

            <div className="nav-link my-2 my-lg-0"  >
                <p className="nav-item cart-image">
                  <img src={require("./images/carts.png")} className="cart-icon" alt="Icon not avilable"></img>
                </p>
              
              </div>

          </li>
                        }

        </ul>
      </div>

    </nav>
  );

}

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/Navbar.js